import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-service-unavailable-banner',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './service-unavailable-banner.component.html',
  styleUrl: './service-unavailable-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceUnavailableBannerComponent {}
